var es = require('./helper/es');
var requireJS = require('./helper/requirejs');

var url = 'http://pingjs.qq.com/tcss.ping.js';
var queue = [];
var state = 0;
var hasPV  = false;
var haswatched = false;

function loadTcssPing (cb) {
  if (state === 2) {
    return cb();
  }

  queue.push(cb);

  if (state === 1) return;

  state = 1;
  requireJS([url], function () {
    // 避免 tcss 的 pv 多次发送
    // 例如：运营活动页面用到 AMS 时，AMS 自带了 tcss 的 pv 统计，
    // 这会导致当前页面 pv 加倍
    window.__pgvmain = pgvMain;

    try {
      Object.defineProperty && Object.defineProperty(window, 'pgvMain', {
        configurable: false,
        writable: false,
        value: '[forbid tcss pv: ams, ...]'
      });
    } catch (e) {}

    state = 2;
    es.each(queue, function (fn) { fn() });
    queue = null;
  }, function () { state = 0 });
}

module.exports = {

  pv : function () {
    // 点击流的页面 pv 确保仅发送一次
    !hasPV && loadTcssPing(function () {
      __pgvmain && __pgvmain("pathtrace", {
        pathStart: true,
        tagParamName: "ADTAG",
        useRefUrl: true,
        override: true,
        careSameDomainRef: false,
        sessionSpan: 60
      });
    });

    hasPV = true;
  },

  click : function (key) {
    loadTcssPing(function () {
      pgvSendClick && pgvSendClick({hottag: key});
    });
  },

  watch: function (nodeId) {
    !haswatched && loadTcssPing(function () {
      document.attachEvent ? document.attachEvent("onclick", function(e) {
          pgvWatchClick(e);
      }) : document.addEventListener("click", function(e) {
          pgvWatchClick(e);
      }, false);
    });

    haswatched = true;
  }

};


//////////////////
// WEBPACK FOOTER
// ./src/api.tcss.js
// module id = 6
// module chunks = 0